import { render, staticRenderFns } from "./yuZhongRecordsTable.vue?vue&type=template&id=2b846f91&scoped=true"
import script from "./yuZhongRecordsTable.vue?vue&type=script&lang=js"
export * from "./yuZhongRecordsTable.vue?vue&type=script&lang=js"
import style0 from "./yuZhongRecordsTable.vue?vue&type=style&index=0&id=2b846f91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b846f91",
  null
  
)

export default component.exports